import api, { Base } from 'ev-api/api';

import { TransformedTwilioFlowResponse } from './responses';
import { transformTwilioWorkflowResponse } from './transformers';

const cdxTwilioApi = api.injectEndpoints({
  endpoints: builder => ({
    getTwilioWorkflows: builder.query<TransformedTwilioFlowResponse, void>({
      query: () => {
        return {
          url: `${Base.V4}/cdx_proxy/config/modules/twilio_flow`,
          method: 'GET',
        };
      },
      transformResponse: transformTwilioWorkflowResponse,
    }),
  }),
});

export const { useGetTwilioWorkflowsQuery } = cdxTwilioApi;
